import ApplicationController from '../application_controller'

class DecimalLimiterController extends ApplicationController {
  validate (event) {
    const value = event.target.value.replace(',', '.').replace(/[^0-9.]/g, '')
    const num = parseFloat(value)
    if (isNaN(num) || num < 0) {
      event.target.value = ''
      return
    }

    const parts = value.split('.')
    if (parts.length === 2 && parts[1].length > 4) {
      parts[1] = parts[1].substring(0, 4)
      event.target.value = parts.join('.')
    }
  }
}

export default DecimalLimiterController
